import { useStateContext } from '../../context/ContextProvider';
import Footer from '../../components/Footer/Footer';
import ImageCarousel from '../../components/ImageSlider/ImageCarousel';
import { PiCheckCircleDuotone } from 'react-icons/pi';
import OtpFormLP2 from '../../components/LeadForm/OtpFormLP2';
import ColorCountdown from '../../components/Countdown/ColorCountdown';
import ColorLeadForm from '../../components/LeadForm/ColorLeadForm';
import ColorImageCarousel from '../../components/ImageSlider/ColorImageCarousel';
import { borderMap, neonMap, textMap, vectorMap } from '../../components/ColorMappingOptions';
import LanguageToggle from '../../components/Language/LanguageToggle';


function ColorLandingPage({
    color = "orange",
    source = null,
    snapchat = false,
    language,
    langToggle = null,
    poster = null,
    video = null,
    images = [],
    heading,
    gridDetails = null,
    imageDetails,
    displayAmenity = true,
    amenityDetails = null,
    // amenities
    displayVisa = true,
    base_url,
    developer,
    project,
    leadType = "Apartment",
    enquiries = null,
    jacuzzi = false,
    purpose = false,
    assignedToManager = null,
    assignedToSales = null,
    contactTime = false,
    otpCode = null,
}) {
    const amenities = [
        {
            "icon": "/assets/images/icons/pool.svg",
            "en_text": "Swimming Pool",
            "ar_text": language == "Arabic" ? "مسبح بانورامي" : "",
        },
        {
            "icon": "/assets/images/icons/gym.svg",
            "en_text": "Fully Equipped Gym",
            "ar_text": "نادي صحي مجهز",
        },
        {
            "icon": "/assets/images/icons/restaurant.svg",
            "en_text": "Restaurants & Cafés",
            "ar_text": "كافيهات ومطاعم راقية",
        },
        {
            "icon": "/assets/images/icons/greenary.svg",
            "en_text": "Gardens & Green Spaces",
            "ar_text": "حدائق ومساحات خضراء",
        },
        {
            "icon": "/assets/images/icons/parking.svg",
            "en_text": "Covered Parking",
            "ar_text": "مواقف سيارات مغطاة",
        },
        {
            "icon": "/assets/images/icons/security.svg",
            "en_text": "24/7 Security",
            "ar_text": "أمن وحراسة على مدار الساعة",
        }
    ];

    const {
        langs,
        langCode,
        t
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    return (
        <>
            <div className={`padding-container flex flex-col items-center justify-between w-full gap-6 md:gap-12 min-h-screen !pt-4 !pb-12`}>
                {/* LOGO */}
                <div className="w-full flex justify-between">
                    {/* <img
                        src="/assets/images/logo/dodeal-properties-white.png"
                        alt="DODEAL PROPERTIES"
                        className="h-[40px] w-auto"
                    /> */}
                    <div></div>
                    {langToggle && (
                        <LanguageToggle
                            redirect={langToggle}
                        />
                    )}
                </div>
                <div className="flex flex-col gap-6">
                    {/* HEADING AND COUNTER */}
                    <div className="flex flex-col gap-5">
                        {/* HEADING */}
                        {heading}
                    </div>

                    {/* IMAGE AND FORM */}
                    <div id="form-container-div" className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center justify-center">
                        {/* HERO IMAGE */}
                        <div className="relative flex items-center justify-center">
                            <div className="absolute top-4 left-1/2 -translate-x-1/2 z-[1]">
                                <ColorCountdown color={color} />
                            </div>
                            {video ? (
                                <video
                                    autoPlay={true}
                                    loop={true}
                                    muted={true}
                                    playsInline={true}
                                    preload="auto"
                                    poster={poster}
                                    width="230"
                                    height="230"
                                    className={`relative rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square`}
                                >
                                    <source src={video} type="video/mp4" />
                                </video>
                            ) : (
                                <img
                                    rel="preload"
                                    src={poster}
                                    alt={`DODEAL PROPERTIES`}
                                    className="relative rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square object-right object-cover"
                                />
                            )}
                            <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-2xl min-w-[230px] min-h-[230px] w-[80%] h-auto max-w-[400px] max-h-[400px] aspect-square border ${borderMap[color]} bg-black z-[-1] rotate-[-7deg]`}></div>
                        </div>

                        {/* FORM */}
                        {otpCode == 101 ? (
                            <ColorLeadForm
                                color={color}
                                base_url={base_url}
                                developer={developer}
                                project={project}
                                leadType={leadType}
                                language={language}
                                enquiries={enquiries}
                                jacuzzi={jacuzzi}
                                purpose={purpose}
                                assignedToManager={assignedToManager}
                                assignedToSales={assignedToSales}
                                contactTime={contactTime}
                            />
                        ) : (
                            <ColorLeadForm
                                color={color}
                                base_url={base_url}
                                developer={developer}
                                project={project}
                                leadType={leadType}
                                language={language}
                                enquiries={enquiries}
                                jacuzzi={jacuzzi}
                                purpose={purpose}
                                assignedToManager={assignedToManager}
                                assignedToSales={assignedToSales}
                                contactTime={contactTime}
                                otpCode={otpCode}
                            />
                        )}
                    </div>

                    {snapchat || source == "Snapchat" ? (
                        <></>
                    ) : (
                        <>
                            {/* DETAILS */}
                            {/* {gridDetails ? (
                    <div className={`p-1 md:p-6 grid grid-cols-3 md:grid-cols-3 gap-x-2 lg:gap-x-4 gap-y-3 border border-transparent ${borderMap[color]} rounded-xl`}>
                        {gridDetails.map((grid, index) => (
                            <>
                                <div key={index} className="flex flex-col items-center justify-center uppercase">
                                    <div className={`${textMap[color]}  ${neonMap[color]}`}>
                                        {grid.topic}
                                    </div>
                                    <div className="text-white text-center">
                                        {grid.text}
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                ) : null} */}

                            {/* IMAGE AND DETAILS */}
                            {imageDetails ? (
                                <>
                                    <div className="md:hidden grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 items-center justify-center">
                                        {/* IMAGES */}
                                        <div className="relative flex items-center justify-center">
                                            <ColorImageCarousel color={color} images={images} />
                                        </div>
                                        {/* DETAILS */}
                                        <div className="flex flex-col gap-4 text-center md:text-start">
                                            {imageDetails?.danger ? (
                                                <h3 className={`text-white font-semibold text-xl lg:text-2xl 2xl:text-3xl capitalize ${color == "gold" ? "primary-text" : textMap[color]}`}
                                                    dangerouslySetInnerHTML={{ __html: imageDetails.title }}
                                                >
                                                </h3>
                                            ) : (
                                                <h3 className="text-white font-semibold text-xl lg:text-2xl capitalize">
                                                    <span className={`${textMap[color]} ${neonMap[color]}`}>
                                                        {imageDetails.title}
                                                    </span>
                                                    <br />
                                                </h3>
                                            )}
                                            <label className="mt-0 mb-0 font-bold">
                                                {imageDetails.desc}
                                            </label>
                                            <div className="w-full flex items-center justify-center">
                                                <div className="relative pt-[20px] w-fit">
                                                    <img
                                                        src={"/assets/images/gifs/arrow.gif"}
                                                        alt="DODEAL PROPERTIES"
                                                        className="brightness-[0] invert-[1] w-[50px] h-auto scale-x-[-1] absolute top-[-25px] left-[-25px]"
                                                    />
                                                    <a
                                                        type="button"
                                                        className={`submit-btn mt-2 min-w-[300px] w-full max-w-[300px] text-center bg-${color}-500 text-white`}
                                                        href="#form-container-div"
                                                    >
                                                        {t("book_now")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="hidden md:grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 items-center justify-center">
                                        {/* DETAILS */}
                                        <div className="flex flex-col gap-4 text-center md:text-start">
                                            {imageDetails?.danger ? (
                                                <h3 className={`font-semibold text-xl lg:text-2xl 2xl:text-3xl capitalize ${color == "gold" ? "primary-text" : `${textMap[color]} ${neonMap[color]}`}`}
                                                    dangerouslySetInnerHTML={{ __html: imageDetails.title }}
                                                >
                                                </h3>
                                            ) : (
                                                <h3 className="text-white font-semibold text-xl lg:text-2xl"                         >
                                                    <span className={`${textMap[color]} ${neonMap[color]}`}>
                                                        {imageDetails.title}
                                                        {imageDetails?.danger}
                                                    </span>
                                                    <br />
                                                </h3>
                                            )}
                                            <label className="mt-0 mb-0 font-bold">
                                                {imageDetails.desc}
                                            </label>
                                            <div className="w-full flex items-center justify-center">
                                                <div className="relative pt-[20px] w-fit">
                                                    <img
                                                        src={"/assets/images/gifs/arrow.gif"}
                                                        alt="DODEAL PROPERTIES"
                                                        className="brightness-[0] invert-[1] w-[50px] h-auto scale-x-[-1] absolute top-[-25px] left-[-25px]"
                                                    />
                                                    <a
                                                        type="button"
                                                        className={`submit-btn mt-2 min-w-[300px] w-full max-w-[300px] text-center bg-${color}-500 text-white`}
                                                        href="#form-container-div"
                                                    >
                                                        {t("book_now")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        {/* IMAGES */}
                                        <div className="relative flex items-center justify-center">
                                            <ColorImageCarousel color={color} images={images} />
                                        </div>
                                    </div>
                                </>
                            ) : null}

                            {/* AMENITIES */}
                            {displayAmenity ? (
                                <div className="flex flex-col gap-6 text-center items-center justify-center w-full">
                                    <h3 className="text-white font-bold text-xl lg:text-2xl neon-white">
                                        {t("amenities")}
                                    </h3>
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-8">
                                        {amenityDetails ? (
                                            amenityDetails?.map((item, index) => (
                                                <>
                                                    <div
                                                        key={index}
                                                        className="flex flex-col gap-4 items-center justify-center h-fit"
                                                    >
                                                        {typeof (item.icon) == "string" ? (
                                                            <img
                                                                src={item.icon}
                                                                alt="DODEAL PROPERTIES"
                                                                className={`h-[60px] w-auto ${vectorMap[color]}`}
                                                            />
                                                        ) : item.icon}
                                                        <p>
                                                            {language == "Arabic" ? item?.ar_text : item?.en_text}
                                                        </p>
                                                    </div>
                                                </>
                                            ))
                                        ) : amenities?.map((item, index) => (
                                            <>
                                                <div
                                                    key={index}
                                                    className="flex flex-col gap-4 items-center justify-center h-fit"
                                                >
                                                    <img
                                                        src={item.icon}
                                                        alt="DODEAL PROPERTIES"
                                                        className={`h-[60px] w-auto ${vectorMap[color]}`}
                                                    />
                                                    <p>
                                                        {language == "Arabic" ? item?.ar_text : item?.en_text}
                                                    </p>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                    <div className="w-full flex items-center justify-center">
                                        <div className="relative pt-[20px] w-fit">
                                            <img
                                                src={"/assets/images/gifs/arrow.gif"}
                                                alt="DODEAL PROPERTIES"
                                                className="brightness-[0] invert-[1] w-[50px] h-auto scale-x-[-1] absolute top-[-25px] left-[-25px]"
                                            />
                                            <a
                                                type="button"
                                                className={`submit-btn mt-2 min-w-[300px] w-full max-w-[300px] self-center md:self-start bg-${color}-500 text-white`}
                                                href="#form-container-div"
                                            >
                                                {t("contact_us")}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {/* GODEN VISA */}
                            {displayVisa ? (
                                <>
                                    {language == "Arabic" ? (
                                        <div className="flex flex-col gap-6 text-center items-center justify-center w-full">
                                            <div className="flex flex-col gap-2">
                                                <img
                                                    src={"/assets/images/icons/visa.svg"}
                                                    alt="DODEAL PROPERTIES"
                                                    className={`h-[60px] w-auto ${vectorMap[color]}`}
                                                />
                                                <h3 className="text-white font-bold neon-white">
                                                    <span className=" text-xl lg:text-2xl">
                                                        احصل على الإقامة الذهبية
                                                    </span>
                                                    <br />
                                                    <span className={`text-xl lg:text-2xl ${textMap[color]} ${neonMap[color]}`}>
                                                        {/* استثمر في عقارك… وابدأ حياة مستقرة في دبي */}
                                                        في الإمارات
                                                    </span>
                                                </h3>
                                                <p className="text-center font-semibold">
                                                    استثمر في عقارك… وابدأ حياة مستقرة في دبي
                                                </p>
                                                <p className="text-center">
                                                    امتلاك عقار في دبي لا يعني فقط امتلاك وحدة فاخرة، بل يمنحك أيضًا فرصة الحصول على الإقامة الذهبية في واحدة من أسرع المدن نموًا في العالم
                                                    بمجرد شرائك عقارًا مؤهلاً، يمكنك التقديم على الإقامة الذهبية لمدة 10 سنوات لك ولعائلتك، دون الحاجة إلى كفيل.
                                                </p>
                                            </div>
                                            <div className="w-[90%] pt-6 flex flex-col gap-4">
                                                <h3 className="text-xl lg:text-2xl font-bold neon-white">
                                                    مزايا الإقامة
                                                    <span className={`${textMap[color]} ${neonMap[color]}`}> الذهبية</span>
                                                </h3>
                                                <p className="text-start">
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            إقامة طويلة الأمد قابلة للتجديد لمدة 10 سنوات.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            تشمل الزوج/الزوجة والأبناء دون قيود عمرية محددة.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            ملكية كاملة للعقار بنسبة 100%.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            حرية الخروج والدخول إلى الإمارات في أي وقت.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            إمكانية تأسيس الأعمال وفتح الحسابات البنكية بسهولة.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            الاستفادة من نظام التعليم والرعاية الصحية في الدولة.
                                                        </div>
                                                    </div>
                                                </p>
                                            </div>
                                            {/* <a
                        type="button"
                        className="submit-btn w-full max-w-[300px]"
                        href="#form-container"
                    >
                        {t("visa_btn")}
                    </a> */}
                                            <div className="w-full flex items-center justify-center">
                                                <div className="relative pt-[20px] w-fit">
                                                    <img
                                                        src={"/assets/images/gifs/arrow.gif"}
                                                        alt="DODEAL PROPERTIES"
                                                        className="brightness-[0] invert-[1] w-[50px] h-auto scale-x-[-1] absolute top-[-25px] left-[-25px]"
                                                    />
                                                    <a
                                                        type="button"
                                                        className={`submit-btn mt-2 min-w-[300px] w-full max-w-[300px] self-center md:self-start bg-${color}-500 text-white`}
                                                        href="#form-container-div"
                                                    >
                                                        {t("visa_btn")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col gap-6 text-center items-center justify-center w-full">
                                            <div className="flex flex-col gap-2">
                                                <img
                                                    src={"/assets/images/icons/visa.svg"}
                                                    alt="DODEAL PROPERTIES"
                                                    className={`h-[60px] w-auto ${vectorMap[color]}`}
                                                />
                                                <h3 className="text-white font-bold neon-white">
                                                    <span className=" text-xl lg:text-2xl">
                                                        Obtain the Golden Residency
                                                    </span>
                                                    <br />
                                                    <span className={`text-xl lg:text-2xl ${textMap[color]} ${neonMap[color]}`}>
                                                        in the UAE
                                                    </span>
                                                </h3>
                                                <p className="text-center font-semibold">
                                                    Invest in your property and start a stable life in Dubai
                                                </p>
                                                <p className="text-center">
                                                    Owning property in Dubai does not only mean having a luxury unit, but it also gives you the opportunity to obtain the Golden Residency in one of the fastest-growing cities in the world.
                                                    Once you purchase an eligible property, you can apply for a 10-year Golden Residency for yourself and your family, without the need for a sponsor.
                                                </p>
                                            </div>
                                            <div className="w-[90%] pt-6 flex flex-col gap-4">
                                                <h3 className="text-xl lg:text-2xl font-bold neon-white">
                                                    Benefits of the
                                                    <span className={`${textMap[color]} ${neonMap[color]}`}> Golden Residency</span>
                                                </h3>
                                                <p className="text-start">
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            Long-term renewable residency for 10 years.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            Includes spouse and children without age restrictions.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            100% full ownership of the property.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            Freedom to enter and exit the UAE at any time.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            Ability to start a business and open bank accounts easily.
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <PiCheckCircleDuotone size={16} className={`${textMap[color]} ${neonMap[color]}`} />
                                                        <div>
                                                            Access to the country’s education and healthcare systems.
                                                        </div>
                                                    </div>
                                                </p>
                                            </div>
                                            <div className="w-full flex items-center justify-center">
                                                <div className="relative pt-[20px] w-fit">
                                                    <img
                                                        src={"/assets/images/gifs/arrow.gif"}
                                                        alt="DODEAL PROPERTIES"
                                                        className="brightness-[0] invert-[1] w-[50px] h-auto scale-x-[-1] absolute top-[-25px] left-[-25px]"
                                                    />
                                                    <a
                                                        type="button"
                                                        className={`submit-btn mt-2 min-w-[300px] w-full max-w-[300px] self-center md:self-start bg-${color}-500 text-white`}
                                                        href="#form-container-div"
                                                    >
                                                        {t("visa_btn")}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : null}
                        </>
                    )}
                </div>
                <Footer />
            </div>
        </>
    );
}

export default ColorLandingPage;
